import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { PaletteMode } from '@mui/material';
import { STORAGE_KEYS } from '../constants';

interface ThemeState {
  mode: PaletteMode;
  toggleTheme: () => void;
  setTheme: (mode: PaletteMode) => void;
}

/**
 * Zustand store for managing theme state
 */
export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      mode: 'light',

      toggleTheme: () => {
        set((state) => ({
          mode: state.mode === 'light' ? 'dark' : 'light',
        }));
      },

      setTheme: (mode) => {
        set({ mode });
      },
    }),
    {
      name: STORAGE_KEYS.THEME_MODE,
    }
  )
);
